// Types
import { TFunction } from 'i18next';

// Constants
import {
  ADDITIONAL_PARTICIPATING_DISTRICTS,
  COMMENTS,
  DATES_AND_TIMES,
  LANGUAGE,
  LOCATION,
  PRESIDENTIAL_REPRESENTATIVE,
  REQUEST_PRES_REP,
} from '@domain/districts';

export const getConferenceHeading: (t: TFunction, value: string) => string = (
  t: TFunction,
  value: string
) => {
  switch (value) {
    case DATES_AND_TIMES:
      return t('conference-constants.dates-and-times', 'Dates and Times');
    case LOCATION:
      return t('conference-constants.location', 'Location');
    case LANGUAGE:
      return t('conference-constants.language', 'Language');
    case ADDITIONAL_PARTICIPATING_DISTRICTS:
      return t(
        'conference-constants.additional-participating-districts',
        'Additional Participating District(s)'
      );
    case PRESIDENTIAL_REPRESENTATIVE:
      return t(
        'conference-constants.presidential-representative',
        'Presidential Representative'
      );
    case COMMENTS:
      return t('conference-constants.comments', 'Comments');
    case REQUEST_PRES_REP:
      return t(
        'conference-constants.request-presidential-representative',
        'Request President Rep'
      );
    default:
      return '';
  }
};
